import { useEffect } from 'react';
import { usePrevious } from '@mafc/hooks';

import { isUndefined } from 'utils/helpers.util';

import Tracker from 'utils/Tracker.checkout';
import { getFormattedExpressDeliverySlot } from '../helpers/getExpressShipmentEntries.helper';

const useExpressGTM = (expressEnable: boolean, expressDeliverySlot?: any) => {
  const flag = usePrevious(expressEnable);

  useEffect(() => {
    if (isUndefined(flag)) {
      return;
    }
    if (flag !== expressEnable) {
      Tracker.gtmExpressToggleClicked(
        expressDeliverySlot ? getFormattedExpressDeliverySlot(expressDeliverySlot) : ''
      );
    }
  }, [flag, expressEnable, expressDeliverySlot]);

  useEffect(() => {
    Tracker.gtmExpressToggleLoaded(
      expressEnable ? getFormattedExpressDeliverySlot(expressDeliverySlot) : ''
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useExpressGTM;
